export enum CatalogueStatus {
  Unlisted = 'Unlisted',
  Listed_Published = 'Listed_Published',
  Listed_Unpublished = 'Listed_Unpublished',
}